import { initializeApp } from "firebase/app";
import { getFunctions, connectFunctionsEmulator, httpsCallable } from "firebase/functions";
import { getStorage, ref } from "firebase/storage";
import { firebaseConfig, useEmulator } from "./fb_env";

import { getAuth, connectAuthEmulator, signInWithCustomToken, onAuthStateChanged, signOut } from "firebase/auth";

const app = initializeApp(firebaseConfig);
const functions = firebaseConfig.region.trim() != "" ? getFunctions(app, firebaseConfig?.region) : getFunctions(app);
const auth = getAuth();

export const storage = getStorage(app);

if (useEmulator) connectFunctionsEmulator(functions, "localhost", 5001);
if (useEmulator) connectAuthEmulator(auth, "http://localhost:9099");

export const firebaseApp = app;
export const firebaseFunctions = functions;
export const firebaseAuth = auth;
export const firebaseStorage = storage;
export const storageRef = ref;

export function getCallable(functionName: string) {
    return httpsCallable(firebaseFunctions, functionName);
}

export function getCallableOption(functionName: string) {
    return httpsCallable(firebaseFunctions, functionName, { timeout: 540000 });
}
export function makeCallApiParam(functionName: string, data: any): { name: string; body: any } {
    return {
        name: functionName,
        body: data,
    };
}
export function getRequestEndpoint(functionName: string): string {
    if (useEmulator) {
        //127.0.0.1:5001/createx-dev-867d2/us-west1/createxUserDownload
        return `http://localhost:5001/${firebaseConfig.projectId}/${firebaseConfig.region}/${functionName}`;
    } else {
        return `https://${firebaseConfig.region}-${firebaseConfig.projectId}.cloudfunctions.net/${functionName}`;
    }
}
